import { fromJS } from 'immutable'
import {
  DIVISION_CREATE_REQUEST,
  DIVISION_CREATE_SUCCESS,
  DIVISION_CREATE_FAILURE,
  DIVISION_CREATE_RESET,
} from './../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case DIVISION_CREATE_REQUEST:
      return state
        .set('isFetching', true)
    case DIVISION_CREATE_SUCCESS:
      return state
        .set('divisionCreate', fromJS(action.payload.createdDivision))
        .set('status', 200)
        .set('message', 'Created Successfully.')
        .set('isFetching', false)
    case DIVISION_CREATE_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('divisionCreate', fromJS(action.payload.message))
        .set('status', fromJS(action.payload.response.statusCode))
        .set('message', fromJS(action.payload.response.message))
        .set('isFetching', false)
    case DIVISION_CREATE_RESET:
      return state
        .delete('divisionCreate')
        .delete('status')
        .delete('message')
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/division/division-create-reducer.js